import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { SearchOrigin } from '@app/search/services/search-tracker.service';
import { SearchSuggestionSource } from '@app/search/search-api.model';

import { WebEnvironmentService } from '@app/shared/services/web-environment.service';
import { SearchFlagsService } from '@app/search/services';

@Component({
  selector: 'dgx-search-opportunities-view',
  templateUrl: './search-opportunities-view.component.html',
})
export class SearchOpportunitiesViewComponent implements OnInit {
  public actionLocation: string;
  public searchOrigin = SearchOrigin.opportunities;
  public suggestionSource = SearchSuggestionSource.AutoSuggestOpportunities;
  public searchTerm$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(
    private webEnvironmentService: WebEnvironmentService,
    private searchFlagsService: SearchFlagsService
  ) {}

  public get showSearchTabs(): boolean {
    return this.searchFlagsService.showSearchLayoutRedesign;
  }

  public ngOnInit(): void {
    this.actionLocation =
      this.webEnvironmentService.analyticsAppLocation ?? 'Search';
  }

  public updateSearchTerm({ term }): void {
    this.searchTerm$.next(term);
  }
}
